module.exports = __webpack_public_path__ + "static/media/tenant3-1.a54ede21.png";